import { isMobileOrTablet } from './getAppLinkByOS'

const openShareWindow = (url: string) => {
  const width = 600
  const height = 600
  const left = (screen.width - width) / 2
  const top = (screen.height - height) / 2
  window.open(url, '_blank', `noopener,noreferrer,width=${width},height=${height},left=${left},top=${top}`)
}

export const shareHandlers = {
  Facebook: (url: string) => openShareWindow(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`),
  LinkedIn: (url: string) => openShareWindow(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`),
  WhatsApp: (text: string) => openShareWindow(`https://${isMobileOrTablet() ? 'api' : 'web'}.whatsapp.com/send?text=${encodeURIComponent(text)}`),
  Gmail: (body: string, subject: string) =>
    openShareWindow(`https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&to=&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`),
  Twitter: (text: string) => openShareWindow(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`),
  Reddit: (text: string) => openShareWindow(`https://www.reddit.com/submit?title=${encodeURIComponent(text)}`),
  Pinterest: (url: string) => openShareWindow(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}`),
  Tumblr: (url: string) => openShareWindow(`https://www.tumblr.com/widgets/share/tool?canonicalUrl=${url}`),
  Telegram: (text: string) => openShareWindow(`https://t.me/share/url?url=${encodeURIComponent(text)}`),
  Xing: (url: string) => openShareWindow(`https://www.xing.com/spi/shares/new?url=${encodeURIComponent(url)}`),
  Snapchat: (url: string) => openShareWindow(`https://www.snapchat.com/scan?attachmentUrl=${encodeURIComponent(url)}`)
}
